import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import cn from 'classnames'
import ScrollToTop from 'react-scroll-up'
import Breadcrumbs from '../../common/Breadcrumbs'
import SeoText from './SeoText'
import Sidebar from './Sidebar'
import Filters from './Filters'
import TagCloud from './TagCloud'
import Products from './Products'
import Pagination from './Pagination'
import Advantages from './Advantages'
import NoFindProducts from './NoFindProducts'
import SeoHeader from './SeoHeader'
import Error from '../../common/Error'
import FAQ from './FAQ'
import Categories from './Filters/Categories'
import SortBy from './Filters/SortBy'
import DataTags from './DataTags'
import {
    breadcrumbsSelector,
    filtersSelector,
    tagsMapSelector,
} from '../selectors'
import Tree from '../utils/tree'
import SeoTabsContainer from './SeoTabsContainer'

import '../store-styles.css'

export default function Root() {
    const isCustomStore = useSelector((state) => state.isCustomStore)
    const breadcrumbs = useSelector(breadcrumbsSelector)
    const filters = useSelector((state) =>
        filtersSelector(state, isCustomStore)
    )
    const tags = useSelector(tagsMapSelector)
    const ownDesignAllowed = useSelector((state) => state.ownDesignAllowed)
    const categories = useSelector((state) => state.categories)
    const sort = useSelector((state) => state.sort)
    const isMobile = useSelector((state) => state.isMobile)

    const [hasError, setHasError] = useState(false)

    return !hasError ? (
        <div className="resp-container content">
            <DataTags />
            <If condition={isMobile && tags}>
                <div className="row content__filters">
                    <Filters
                        filters={filters}
                        categories={new Tree(categories)}
                        tags={tags}
                        ownDesignAllowed={ownDesignAllowed}
                        sort={sort}
                        isCustomStore={isCustomStore}
                    />
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Breadcrumbs items={breadcrumbs} />
                        {!isCustomStore && <SeoHeader />}
                    </div>
                </div>
            </If>
            <If condition={!isMobile}>
                <div className="row">
                    <div className="col-xs-12">
                        <Breadcrumbs items={breadcrumbs} />
                        <SeoHeader />
                    </div>
                </div>
            </If>
            <div className="row">
                <If condition={!isMobile && tags}>
                    <div className="col-md-2 hidden-xs hidden-sm">
                        <Sidebar
                            tags={tags}
                            filters={filters}
                            isCustomStore={isCustomStore}
                            categories={new Tree(categories)}
                            sort={sort}
                            ownDesignAllowed={ownDesignAllowed}
                        />
                        <SeoText
                            type="afterMenuText"
                            className="after-menu-text"
                        />
                    </div>
                </If>
                <div className="col-xs-12 col-md-10">
                    <If condition={!isMobile && !isCustomStore}>
                        <div className="row content__filters">
                            <div
                                className={cn(
                                    'filters',
                                    'for-hint',
                                    'clearfix',
                                    {
                                        ['filters_custom-store']: isCustomStore,
                                    }
                                )}
                            >
                                <div className="col-md-9 hidden-xs hidden-sm filters-item for-hint">
                                    <Categories
                                        categories={new Tree(categories)}
                                        isCustomStore={isCustomStore}
                                        filters={filters}
                                    />
                                </div>
                                <div className="col-md-3 hidden-xs hidden-sm filters-item">
                                    <SortBy sort={sort} filters={filters} />
                                </div>
                            </div>
                        </div>
                    </If>
                    <div className="row content__tag-cloud hidden-sm hidden-xs">
                        <div className="col-md-12">
                            <TagCloud tags={tags} filters={filters} />
                        </div>
                    </div>
                    <div className="row content__products">
                        <Products />
                    </div>
                    <div className="content__pagination">
                        <Pagination isCustomStore={isCustomStore} />
                    </div>
                    <If condition={!isCustomStore}>
                        <div className="content__tabs">
                            <SeoTabsContainer />
                        </div>
                    </If>
                    <If condition={!isCustomStore || ownDesignAllowed}>
                        <div className="content__no-find-products">
                            <NoFindProducts filters={filters} />
                        </div>
                    </If>
                    <div className="content__advantages">
                        <Advantages />
                    </div>
                    <div className="content__faq">
                        <FAQ />
                    </div>
                    <If condition={isMobile}>
                        <div className="content__after-menu-text">
                            <SeoText
                                type="afterMenuText"
                                className="after-menu-text"
                            />
                        </div>
                    </If>
                    <SeoText
                        type="beforeFooterText"
                        className="before-footer-text text-center"
                    />
                    <ScrollToTop
                        showUnder={160}
                        style={{
                            position: 'fixed',
                            bottom: isMobile ? 20 : 35,
                            [isMobile ? 'left' : 'right']: 20,
                            cursor: 'pointer',
                            transitionDuration: '0.2s',
                            transitionTimingFunction: 'linear',
                            transitionDelay: '0s',
                            width: 65,
                            height: 65,
                            backgroundColor: '#333',
                            borderRadius: 37,
                            color: '#fff',
                            fontSize: 40,
                            lineHeight: '60px',
                            textAlign: 'center',
                            zIndex: 1,
                        }}
                    >
                        <i className="fas fa-chevron-up" />
                    </ScrollToTop>
                </div>
            </div>
        </div>
    ) : (
        <div className="resp-container">
            <Error />
        </div>
    )
}
